export const rumConfig = {
    sessionSampleRate: Number(process.env.REACT_APP_RUM_SESSION_SAMPLE_RATE),
    identityPoolId: process.env.REACT_APP_RUM_IDENTITY_POOL_ID,
    endpoint: process.env.REACT_APP_RUM_ENDPOINT,
    telemetries: (process.env.REACT_APP_RUM_TELEMETRIES || "performance,errors,http").split(","),
    allowCookies: process.env.REACT_APP_RUM_ALLOW_COOKIES === "true",
    enableXRay: process.env.REACT_APP_RUM_ENABLE_XRAY === "true",
    signing: process.env.REACT_APP_RUM_SIGNING !== "false",
    guestRoleArn: process.env.REACT_APP_RUM_GUEST_ROLE_ARN,
    enableRumClient: process.env.REACT_APP_RUM_ENABLE_CLIENT !== "false",
    sessionEventLimit: Number(process.env.REACT_APP_RUM_SESSION_EVENT_LIMIT),
    recordAllRequests: process.env.REACT_APP_RUM_RECORD_ALL_REQUESTS === "true"
};

export const APPLICATION_ID = process.env.REACT_APP_RUM_APPLICATION_ID;
export const APPLICATION_VERSION = process.env.REACT_APP_RUM_APPLICATION_VERSION;
export const APPLICATION_REGION = process.env.REACT_APP_RUM_APPLICATION_REGION;